import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const industriesService = (): Promise<AxiosResponse> => {
  return axiosAuth.get(API_PATH().apis.industries);
};

export const businessunitTypesService = (): Promise<AxiosResponse> => {
  // let user = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")||"");
  // let token =  user?.owner || user?.id;
  return axiosAuth.get(API_PATH().apis.businessUnitTypes);
};
export const createBusinessUnitService = (
  businessUnitObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.businessUnit, businessUnitObject);
};
export const updateBusinessUnitService = (
  businessUnitObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.businessUnit, businessUnitObject);
};

export const deleteBusinessUnitService = (
  businessUnitObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.deleteBusinessUnit, businessUnitObject);
};

export const businessUnitActionsService = (
  businessUnitActionsObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(
    API_PATH().apis.businessUnitActions,
    businessUnitActionsObject
  );
};

export const fetchCompanyAndBusinessUnits = (
  businessUnitObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(
    API_PATH().apis.companyBusinessUnits,
    businessUnitObject
  );
};

export const fetchUser = (userId: any): Promise<AxiosResponse> => {
  const url = API_PATH().apis.addemployee + "/" + userId;
  return axiosAuth.get(API_PATH().apis.addemployee + "/" + userId);
};

export const fetchBusinessUnits = (
  businessUnitObject: any
): Promise<AxiosResponse> => {
  const bunitsStr = localStorage.getItem("bunits");

  let company =
    localStorage.getItem("company") &&
    JSON.parse(localStorage.getItem("company") || "").id;
  let config: AxiosRequestConfig = {
    params: {
      company: company,
    },
  };
  if (bunitsStr) {
    config.params.businessUnitIds = bunitsStr;
  }
  if (businessUnitObject?.controller) {
    config.params.page = (businessUnitObject?.controller?.page || 0) + 1;
    config.params.limit = businessUnitObject?.controller?.limit;
    config.params.searchText = businessUnitObject.searchText;
  } else if (businessUnitObject?.emissionTarget) {
    config.params.emissionTarget = true;
    businessUnitObject?.hasTarget && (config.params.hasTarget = true);
  }
  if (
    businessUnitObject?.controller?.sortBy &&
    businessUnitObject?.controller?.sortOrder
  ) {
    config.params.sortBy = businessUnitObject?.controller?.sortBy;
    config.params.sortOrder = businessUnitObject?.controller?.sortOrder;
  }
  if (businessUnitObject?.filter?.types) {
    config.params.types = businessUnitObject?.filter?.types;
  }
  if (businessUnitObject?.filter?.status) {
    config.params.status = businessUnitObject?.filter?.status;
  }

  return axiosAuth.get(API_PATH().apis.businessUnits, config);
};

export const fetchBusinessUnit = (
  businessUnitId: number,
  data?: any
): Promise<AxiosResponse> => {
  const params: any = {
    id: businessUnitId.toString(),
  };
  if (data?.fetchAllPreferences) {
    params["fetchAllPreferences"] = true;
  }
  let config: AxiosRequestConfig = {
    params,
  };
  //    config.params.page = (businessUnitObject.page || 0) +1;
  //    config.params.limit = businessUnitObject.limit;

  return axiosAuth.get(API_PATH().apis.businessUnit, config);
};
export const fetchBusinessUnitPreference = (
  businessUnitId: number,
  showCategory: boolean = false,
  data?: any
): Promise<AxiosResponse> => {
  const params: any = {
    businessUnit: businessUnitId.toString(),
    showCategory: showCategory,
  };
  if (data?.fetchAllPreferences) {
    params["fetchAllPreferences"] = true;
  }
  let config: AxiosRequestConfig = {
    params,
  };
  return axiosAuth.get(API_PATH().apis.businessUnitPreference, config);
};

export const fetchDefaultCategoryPreferences = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };
  return axiosAuth.get(API_PATH().apis.defaultpreferences, config);
};
export const updateSettingsInfoService = (
  settingsInfoObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.settingsInfo, settingsInfoObject);
};
export const fetchCompany = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };

  return axiosAuth.get(API_PATH().apis.company, config);
};

export const getSettingPreferences = (
  fetchReports: boolean,
  company?: number
): Promise<AxiosResponse> => {
  let params: any = {};
  if (fetchReports) params["fetchReports"] = true;
  let config: AxiosRequestConfig = {
    params,
  };
  return axiosAuth.get(API_PATH().apis.companypreferences, config);
};

export const updateSettingPreference = (
  settingPreference: any
): Promise<AxiosResponse> => {
  // settingPreference.company = company;
  return axiosAuth.put(API_PATH().apis.companypreferences, settingPreference);
};

export const fetchTrainingVideos = (
  requestObject: any
): Promise<AxiosResponse> => {
  let params: any = {};
  if (requestObject?.searchText)
    params["searchText"] = requestObject.searchText;
  let config: AxiosRequestConfig = {
    params,
  };
  return axiosAuth.get(API_PATH().apis.trainingVideos, config);
};

export const fetchCompanyOrBusinessUnitByRegistration = (
  regId: string,
  isBusinessUnit: boolean
) => {
  return axiosAuth.get(API_PATH().apis.getCompanyOrFacility, {
    params: { registrationId: regId, isBusinessUnit: isBusinessUnit },
  });
};

export const fetchBusinessUnitsCount = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };

  return axiosAuth.get(API_PATH().apis.businessunitsCount, config);
};

export const addDisclosure = (data: any) => {
  return axiosAuth.post(API_PATH().apis.disclosure, data);
};

export const updateDisclosure = (data: any) => {
  return axiosAuth.put(API_PATH().apis.disclosure, data);
};

export const getDisclosure = (year: any, reportType: string) => {
  let config: AxiosRequestConfig = {
    params: { year: year, reportType: reportType },
  };
  return axiosAuth.get(API_PATH().apis.disclosure, config);
};

export const downloadGRIIndex = (year: any) => {
  return axiosAuth.post(
    API_PATH().apis.downloadGRIIndex,
    { year },
    {
      responseType: "arraybuffer",
    }
  );
};

export const nicCodesService = (): Promise<AxiosResponse> => {
  return axiosAuth.get(API_PATH().apis.niccodes);
};
export const downloadBRSRDataReport = (
  requestObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.brsrData, requestObject, {
    responseType: "arraybuffer",
  });
};
